import { OrderSummaryCard } from '@euler/app/components/order/summary/OrderSummaryCard';
import { useServiceRecordContext } from '@euler/app/flows/record/ServiceRecordContext';
import { useServiceRecordQrcodeSharing } from '@euler/app/flows/record/functions/useServiceRecordQrcodeSharing';
import { ChildRecordList } from '@euler/app/flows/record/pages/detail/components/ChildRecordList';
import { QuotationSection } from '@euler/app/flows/record/pages/detail/components/QuotationSection';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { OrderDetail } from '@euler/model';
import { InspectionTaskStatus } from '@euler/model/enum';
import { Maybe } from '@euler/types';
import { memo } from 'react';
import { ServiceRecordCommentSection } from './CommentSection';
import { FaultInspections } from './FaultInspections';
import { MaintenancePlans } from './MaintenancePlans';
import { ServiceRecordMenu } from './Menu';
import { RecentServiceRecords } from './RecentServiceRecords';
import { ServiceRecordRemarkSection } from './RemarkSection';
import { ReportList } from './ReportList';
import { ServiceSubjects } from './ServiceSubjects';

export const ServiceRecordDetailContent = memo(
  ({
    orderDetail,
    onShowDetail,
  }: {
    orderDetail: Maybe<OrderDetail>;
    onShowDetail?: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const { serviceRecord, refresh } = useServiceRecordContext();

    const { onShare: onQrcodeSharingPress } = useServiceRecordQrcodeSharing(
      () => refresh(true /** refresh silently */),
    );

    return (
      <>
        <OrderSummaryCard
          orderDetail={orderDetail}
          isMainOrder={serviceRecord.isMainRecord}
          isFirstTimeOrder={serviceRecord.isFirstTimeOrder ?? false}
          status={InspectionTaskStatus.Finished}
          createdAt={serviceRecord.orderedAt}
          finishedAt={serviceRecord.finishedAt}
          orderNo={serviceRecord.orderNo}
          //serviceRecordId={__DEV__ ? serviceRecord._id : undefined}
          licensePlateNo={serviceRecord.licensePlateNo}
          vin={serviceRecord.vin}
          storeName={serviceRecord.storeName}
          serviceAgentName={serviceRecord.serviceAgentName}
          serviceAgentChatByName
          vehicleMileage={serviceRecord.mileage}
          vehicleName={serviceRecord.vehicleName}
          vehicleBrandLogo={serviceRecord.vehicleBrandLogo}
          vehicleFuelType={serviceRecord.vehicleFuelType}
          customerSigned={serviceRecord.signImgUrl != null}
          customerType={serviceRecord.customerType}
          customerName={serviceRecord.customerName}
          customerMobile={serviceRecord.customerMobile}
          returnType={serviceRecord.returnType}
          carwashType={serviceRecord.carwashType}
          oldPartDisposalType={serviceRecord.oldPartDisposalType}
          reservationType={serviceRecord.reservationType}
          estimatedFinishTime={null}
          insuranceExpiryDate={serviceRecord.insuranceExpiryDate}
          tags={serviceRecord.tags}
          subscribed={serviceRecord.subscribed}
          brandLogoPosition="right"
          onShowDetail={onShowDetail}
          onQrcodeSharingPress={onQrcodeSharingPress}
          hideServiceRecordCount
          css={`
            margin-bottom: ${rpx(15)}px;
          `}
        />
        <ServiceRecordMenu showRollback />
        <ServiceSubjects />
        {serviceRecord.isMainRecord && <MaintenancePlans />}
        <FaultInspections />
        <QuotationSection />
        <ReportList />
        {serviceRecord.hasChildRecords && <ChildRecordList />}
        <ServiceRecordRemarkSection remark={serviceRecord.remark} />
        <ServiceRecordCommentSection comment={serviceRecord.comment} />
        <RecentServiceRecords />
      </>
    );
  },
);
